import dayjs, { Dayjs } from "dayjs";

const EARLIEST_RELEASE_YEAR = 1888;

/** A stored year the picker can show. The database default `1` is not a year. */
export function releaseYearValue(value: unknown): Dayjs | undefined {
  if (dayjs.isDayjs(value)) {
    if (!value.isValid()) return undefined;
    const year = value.year();
    if (year < EARLIEST_RELEASE_YEAR || year > dayjs().year() + 1) return undefined;
    return value;
  }

  if (value == null || value === "") return undefined;
  const text = String(value);
  if (!/^\d{4}$/.test(text)) return undefined;
  const year = Number(text);
  if (year < EARLIEST_RELEASE_YEAR || year > dayjs().year() + 1) return undefined;
  return dayjs(text, "YYYY");
}
